var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"style":{"fill":"#DB812C"}},React.createElement("svg",{"fill":"#DB812C;","version":"1.1","x":"-12px","y":"-20px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"},React.createElement("path",{"d":"M57.8,31.7c3.2,3.2,15.8,15.8,16,16c3.1,3,7.9,3,11,0c3.1-3,3.1-8,0-11C84.6,36.5,55.5,7.3,55.5,7.3c-3.1-3.1-8.1-3.1-11,0  c0,0-28.8,28.7-29.4,29.4c-3,3-3,7.9,0,11c3.1,3,8.1,3,11.1,0c0.6-0.6,16-16.1,16-16.1v55.5c0,4.3,3.5,7.8,7.8,7.8  c4.3,0,7.8-3.5,7.8-7.8V31.7z"})))));
}

ArrowUp.defaultProps = {"className":"icon-leading icon-middle","width":"20px","height":"20px","viewBox":"0 0 100 100"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
